import React from 'react';
import { useSelector } from 'react-redux';
import FormattedCurrency from '../../../../../components/formatted-currency';
import style from '../style.module.less';
import Global from '../../../../../store/global-selectors';

const ShipmentsRatedCostColumn = ({ fulfillmentPlanSetId }) => {
  const fulfillmentPlanSet = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanSetById(state, {
      fulfillmentPlanSetId,
    }),
  );
  const { shipmentsRatedCost, currencyType } = fulfillmentPlanSet ?? {};

  if (!shipmentsRatedCost) {
    return null;
  }

  const { value, code } = shipmentsRatedCost;
  const currencyCode = code || currencyType;

  return (
    <div className={style['right-aligned']}>
      <FormattedCurrency currencyCode={currencyCode} value={value} />
    </div>
  );
};

export default {
  id: 'shipments-rated-cost',
  messageDescriptorKey: 'shipmentsRatedCost',
  width: 180,
  nonsortable: true,
  render: ({ fulfillmentPlanSetId }) => <ShipmentsRatedCostColumn fulfillmentPlanSetId={fulfillmentPlanSetId} />,
};
